import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  vpsFree: null,
  vpsPaid: null,
  monitoring: null,
};

export const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    setFeaturesVpsFree: (state, action) => {
      state.vpsFree = action.payload;
    },
    setFeaturesVpsPaid: (state, action) => {
      state.vpsPaid = action.payload;
    },
    setFeaturesMonitoring: (state, action) => {
      state.monitoring = action.payload;
    },

    resetFeatures: () => initialState,
  },
});

export const {
  setFeaturesVpsFree,
  setFeaturesVpsPaid,
  setFeaturesMonitoring,

  resetFeatures,
} = featuresSlice.actions;

export default featuresSlice.reducer;
